/* eslint-disable no-restricted-syntax */
import { apiService } from '../services';

const state = {
  // List of resources available from the db
  // items in this list will ne refreshed from data store automatically
  // Note endpoints are singular, but resource plural
};

const getters = {
  lookup: state => (resource, id) => {
    if (state[resource]) {
      const res = state[resource].find(element => element.id === id);
      return res === undefined ? '' : res.title;
    }
    return '';
  },
  artMediaByForm: state => (artFormTitle) => {
    console.log();
    const artForm = state.art_forms.find(item => item.title === artFormTitle);
    if (artForm) {
      const media = state.art_media.filter(item => item.art_form_id === artForm.id);
      return media;
    }
    return [];
  },
  // getDefects: state => defectType =>
  //   state.defects.filter(item => item.type === defectType),
};

const actions = {
  async updateState({ commit, dispatch }) {
    // eslint-disable-next-line guard-for-in
    for (const resource in state) {
      // Loop through all resources and fetch from API
      try {
        // eslint-disable-next-line no-await-in-loop
        const data = await apiService.getResource(resource);
        commit('popResource', { resource, data });
      } catch (error) {
        dispatch('alert/error', error, { root: true });
      }
    }
  },
  // Generic resource functions
  async getResource({ commit, dispatch }, resource) {
    try {
      const data = await apiService.getResource(resource);
      commit('popResource', { resource, data });
    } catch (error) {
      dispatch('alert/error', error, { root: true });
    }
  },
};

const mutations = {
  popResource(state, { resource, data }) {
    state[resource] = data;
  },
};

export const resource = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/resource.module.js